import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function AadhaarPayMerchant() {
  const faqs = [
    {
      question: "What is Mokshiq Aadhaar Pay Merchant Software?",
      answer: "Aadhaar Pay Merchant Software (by Rakle Service Private Limited) allows merchants and retailers to accept payments from customers directly from their Aadhaar-linked bank accounts using biometric fingerprint authentication without requiring a debit card or UPI PIN."
    },
    {
      question: "What is the daily transaction limit for Aadhaar Pay?",
      answer: "Customers can pay up to ₹10,000 per transaction per day per bank account depending on individual bank limits set by NPCI."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-fingerprint me-2"></i>Biometric Merchant Payment
            </span>
            <h1 className="page_title text-white mb-3">Aadhaar Pay Merchant Software</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Cardless biometric merchant payment collection powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Banking Software</a></li>
              <li className="active"><a href="#!">Aadhaar Pay Merchant</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-fingerprint text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Cardless &amp; PIN-Less</h3>
                  <p className="text-muted small">Accept customer payments using only Aadhaar Number, Bank Name, and Biometric Fingerprint scan.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-building-columns text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Instant Wallet Credit</h3>
                  <p className="text-muted small">Merchant wallet credited immediately with 24x7 instant IMPS settlement to bank account.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-shield-halved text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">NPCI 2FA Compliant</h3>
                  <p className="text-muted small">Operates on official UIDAI/NPCI biometric RD services (Mantra, Morpho, Startek, Precision).</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Aadhaar Pay FAQs" subtitle="Frequently asked questions about Aadhaar Pay merchant software." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default AadhaarPayMerchant;
